import React from "react";
import { Box, Chip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface SearchInputChipPropType {
  searchField: string;
  searchValue?: any; // TODO: why don't we ever pass this in anywhere
  filteredRole?: string;
  searchChipOpen?: boolean;
  searchBluePillValue: string;
  columnFilterSearchField?: string;
  routeChange?: () => void;
  resetTableRows?: () => void;
  resetFilter: React.Dispatch<React.SetStateAction<string>>;
  resetFilterRole?: React.Dispatch<React.SetStateAction<string>>;
  resetSearchValue: React.Dispatch<React.SetStateAction<string>>;
  setSearchChipOpen?: () => void;
  defaultSearchParam?: string;
}

export default function SearchInputChip(props: SearchInputChipPropType) {
  const onDelete = () => {
    props?.resetTableRows && props?.resetTableRows();
    props?.resetFilter(props.defaultSearchParam ?? "");
    props?.resetSearchValue("");
    props?.setSearchChipOpen && props?.setSearchChipOpen();
    props?.resetFilterRole && props.resetFilterRole("");
    props?.routeChange && props?.routeChange();
  };

  return (props.searchChipOpen && props.columnFilterSearchField && (props.searchBluePillValue || props.searchValue)) || props.filteredRole?.length ? (
    <Box style={{ marginRight: "13px" }}>
      <Chip
        label={`${props.filteredRole?.length && props.searchField === "Role" ? "Role" : props.columnFilterSearchField} : ${props.searchBluePillValue.length ? props.searchBluePillValue : props.searchValue}`}
        sx={{
          border: "2px #39A2DB solid",
          bgcolor: "#ffffff",
          color: "#39A2DB",
          height: "42px",
          fontSize: "18px",
          lineHeight: "22px",
          borderRadius: '24px'
        }}
        onDelete={onDelete}
        deleteIcon={<CloseIcon sx={{ color: "#39A2DB !important" }} />}
      />
    </Box>
  ) : <></>
}
